jQuery($ => {

  if($('.o-product__featured')[0]){
    $('.o-product__featured > .m-image-gallery__list').slick({
      slidesToShow  : 1,
      slidesToScroll: 1,
      arrows        : false,
      dots          : false,
      fade          : true,
      adaptiveHeight: true,
      asNavFor      : $('.o-product__gallery .m-image-gallery__list'),
    });
  }

  if($('.o-product__gallery')[0]){
    $('.o-product__gallery > .m-image-gallery__list').slick({
      slidesToShow  : 4,
      slidesToScroll: 1,
      arrows        : true,
      dots          : false,
      focusOnSelect : true,
      appendArrows  : $('.o-product__navigation-arrows'),
      asNavFor      : $('.o-product__featured .m-image-gallery__list'),
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    })
  }

  $('.o-product__quantity .m-field__input').change(function(){
    let $quantityValue = $(this).val();
    const $button = $('.o-product__button');

    $button.attr('data-item-quantity', $quantityValue);
  });

  $('.o-product__size').on('mousedown keydown', '.a-select__item', function(){
    let $sizeValue = $(this).data('value');
    const $button = $('.o-product__button');

    $button.attr('data-item-custom1-value', $sizeValue);
  })

});